<style lang="scss">


</style>

<template>
	<div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar"
			style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{$t('zuijinbaojing')}}
				</p>
			</div>


		</div>
		<div :style="{'height':contentHeight+'px'}">
			<div style="display: flex;" v-if="alarm">
				<div style="width: 30%;">
					<p style="font-size: 14px;color: #C0C4CC;">{{$t('kaishishijian')}}</p>

					<p style="font-size: 18px;color: #ffffff;" v-if="alarm.begin">{{dayjs.unix(alarm.begin/1000).format('MM-DD HH:mm')}}</p>
				</div>
				<div style="width: 30%;">
					<p style="font-size: 14px;color: #C0C4CC;">{{$t('jieshushijian')}}</p>
					<p style="font-size: 18px;color: #ffffff;" v-if="alarm.end">{{dayjs.unix(alarm.end/1000).format('MM-DD HH:mm')}}</p>
				</div>
				<div style="width: 40%;">
					<p style="font-size: 14px;color: #C0C4CC;">{{$t('baojingneirong')}}</p>
					<p style="font-size: 18px;color: #ffffff;">{{$t(alarm.i18n)}}</p>
				</div>
			</div>
		</div>

	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_workshop_equipment_alert',
		components: {

		},
		props: {
			equipment: {
				type: Object,
				default: function() {
					return {}
				},
			},

		},
		data() {
			return {
				timmer: null,
				contentHeight: 0,
				alarm: null,
			};
		},
		created() {
			this.timmer = setInterval(() => {
				this.lastAlarm()
			}, 120000)
			this.lastAlarm()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					if (!this.$refs.titleBar) {
						return;
					}
					this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
						20 - 20
					this.rowHeight = (this.contentHeight - 42 - 5) / 10
				}, 500)

			},
			async lastAlarm() {

				let response = await this.http.get('/web/equipment/lastAlarm', {
					params: {
						equipmentId: this.equipment.id
					}
				})
				if(response.data.length>0){
					this.alarm = response.data[0]
				}else{
					this.alarm = null
				}


			},

		}
	};
</script>
